import { Link } from "react-router-dom";
import { NAV } from "../data/content";
import { useSiteContent } from "../context/SiteContentContext";
import { Logo } from "./Logo";

export const Footer = () => {
  const { org } = useSiteContent();
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white mt-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <Logo className="h-14 w-14" />
            <div className="leading-tight">
              <div className="font-display text-2xl">Creative Flare Yorkshire</div>
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#EC4899]">Community Interest Company</div>
            </div>
          </div>
          <p className="font-display text-3xl md:text-4xl leading-tight mt-8 text-white/95">
            Supporting local people through <span className="text-[#EC4899]">creative</span>, inclusive activities.
          </p>
          <p className="mt-6 text-sm text-white/60 max-w-md">
            Company Number {org.companyNumber} · A Bradford Community Interest Company.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-[#EC4899]">Explore</h4>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-[15px] text-white/80 hover:text-[#EC4899] transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-[#EC4899]">Registered Office</h4>
          <p className="mt-5 text-[15px] text-white/80 leading-relaxed">
            {org.registeredAddress.line1}<br />
            {org.registeredAddress.line2}
          </p>
          <h4 className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-[#EC4899]">{org.venue.label}</h4>
          <p className="mt-3 text-[15px] text-white/80">{org.venue.name}</p>

          <div className="mt-6 flex flex-wrap gap-4">
            {org.socials.map((s) => (
              <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={`footer-social-${s.name.toLowerCase()}`} className="text-[13px] tracking-wide text-white/65 hover:text-[#EC4899]">
                {s.name}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Creative Flare Yorkshire C.I.C. · Company No. {org.companyNumber}</p>
          <p className="font-mono tracking-wider">Made in Bradford, for Bradford</p>
        </div>
      </div>
    </footer>
  );
};
